// import { Sidebar } from '../icons/Sidebar';
import { Sidebar } from 'lucide-react';
import { SidebarClose, SidebarOpen } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger
} from '@/components/ui/tooltip';
import { Translator } from 'components/i18n';

import { useSidebar } from '../ui/sidebar';

export default function SidebarTrigger({
    tooltip = true,
    tooltipSide = 'right'
}: {
    tooltip?: boolean;
    tooltipSide?: 'top' | 'right' | 'bottom' | 'left';
}) {
    const { setOpen, open, openMobile, setOpenMobile, isMobile } = useSidebar();

    const button = (
        <Button
            id="sidebar-trigger-button"
            onClick={() =>
                isMobile ? setOpenMobile(!openMobile) : setOpen(!open)
            }
            variant="ghost"
            size="icon"
        >
            {open ? (
                <SidebarClose
                    strokeWidth={1.5}
                    className="text-foreground"
                />
            ) : (
                <SidebarOpen
                    strokeWidth={1.5}
                    className="text-foreground"
                />
            )}
        </Button>
    );

    if (!tooltip) {
        return button;
    }

    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>{button}</TooltipTrigger>
                <TooltipContent side={tooltipSide}>
                    {open ? (
                        <Translator path="threadHistory.sidebar.actions.close" />
                    ) : (
                        <Translator path="threadHistory.sidebar.actions.open" />
                    )}
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
